import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import type {RootState} from '../store';
import {Nft, WalletData} from '@/lib/types';

interface MetaAnchorState {
    cache: Record<string, WalletData>;
}

const initialState: MetaAnchorState = {
    cache: {},
};

export const metaAnchorSlice = createSlice({
    name: 'metaAnchor',
    initialState,
    reducers: {
        setNFTData: (state, action: PayloadAction<{ walletAddress: string; nft: Nft }>) => {
            const {walletAddress, nft} = action.payload;
            const existing = state.cache[walletAddress];
            const nfts = existing ? [...existing.nfts, nft] : [nft];

            state.cache[walletAddress] = {
                walletAddress,
                nfts,
                timestamp: Date.now(),
            };
        },
        setAllNFTData: (state, action: PayloadAction<{ walletAddress: string; nfts: Nft[] }>) => {
            const {walletAddress, nfts} = action.payload;
            state.cache[walletAddress] = {
                walletAddress,
                nfts,
                timestamp: Date.now(),
            };
        },
        clearNFTData: (state, action: PayloadAction<string | undefined>) => {
            const walletAddress = action.payload;
            if (walletAddress) {
                delete state.cache[walletAddress];
            } else {
                state.cache = {};
            }
        },
        clearAllNFTData: (state) => {
            state.cache = {};
        },
    },
});

export const {setNFTData, setAllNFTData, clearNFTData, clearAllNFTData} = metaAnchorSlice.actions;

export const selectCache = (state: RootState) => state.metaAnchor.cache;
export const selectNFTData = (walletAddress: string) => (state: RootState) =>
    state.metaAnchor.cache[walletAddress];
export const selectAllNFTData = (state: RootState) => state.metaAnchor.cache;

export default metaAnchorSlice.reducer;
